import type { CSSProperties } from "react";

/**
 * The standard account content-card surface: white fill, 1px hairline border,
 * 3px radius, 24px padding. Shared by the profile / notifications / subscription
 * cards (each previously defined a byte-identical local `cardStyle`).
 */
export const ACCOUNT_CARD_STYLE: CSSProperties = {
  backgroundColor: "white",
  border: `1px solid rgba(0,0,0,0.3)`,
  borderRadius: "3px",
  padding: "24px",
};
